var panelCtrl = (function () {
  return {
    approval: function ($scope, Api) {
      // User Counters
      $scope.userApprovalCount = 0;

      var counters = function () {
        var callCounters = {
          COMMUNITY: 0,
          GROUPS_ADM: 0,
          GROUPS_NOADM: 0,
          COURSES_ADM: 0,
          COURSES_NOADM: 0
        };

        var counter = function (key) {
          var requestUrl = 'user/counter';

          if (key == 'COMMUNITY') requestUrl = 'user/counter?signup_pending=true';
          else if (key == 'GROUPS_ADM') requestUrl = 'user/counter?signup_pending=true&scope=my_groups';
          else if (key == 'GROUPS_NOADM') requestUrl = 'user/counter?signup_pending=true&scope=others_groups';
          else if (key == 'COURSES_ADM') requestUrl = 'course/users?return_as=count&signup_pending=true&scope=my_courses';
          else if (key == 'COURSES_NOADM') requestUrl = 'course/users?return_as=count&signup_pending=true&scope=others_courses';

          Api.get(requestUrl, function (err, resp) {
            if (!err) $scope.userApprovalCount += resp.response ? resp.response : 0;
          });
        };

        if ($scope.$parent.currentUser.role === 'ADM') {
          for (var key in callCounters) counter(key);
        } else counter('GROUPS_ADM');

        // Post approval counter
        const postApprovalScope = $scope.currentUser.role === 'ADM' ? 'ALL' : 'ADMGROUPS';
        $scope.loadData(`article/counter?mode=PENDING&status=${postApprovalScope}`, 'pendingContent');

        // Comment counter
        var commentCall = $scope.currentUser.isadmin ? 'status=2&scope=all&collection=articles' : 'status=2&scope=in_my_content&collection=articles';
        $scope.loadData(`comment?return_as=count&${commentCall}`, 'pendingComment');
      };

      counters();
    },

    blocked: function ($scope, Api) {
      // User Counters
      $scope.userApprovalCount = 0;

      var counters = function () {
        var callCounters = {
          COMMUNITY: 0,
          GROUPS_ADM: 0,
          GROUPS_NOADM: 0,
          COURSES_ADM: 0,
          COURSES_NOADM: 0
        };

        var counter = function (key) {
          var requestUrl = 'user/counter';

          if (key == 'COMMUNITY') requestUrl = 'user/counter?signup_pending=true';
          else if (key == 'GROUPS_ADM') requestUrl = 'user/counter?signup_pending=true&scope=my_groups';
          else if (key == 'GROUPS_NOADM') requestUrl = 'user/counter?signup_pending=true&scope=others_groups';
          else if (key == 'COURSES_ADM') requestUrl = 'course/users?return_as=count&signup_pending=true&scope=my_courses';
          else if (key == 'COURSES_NOADM') requestUrl = 'course/users?return_as=count&signup_pending=true&scope=others_courses';

          Api.get(requestUrl, function (err, resp) {
            if (!err) $scope.userApprovalCount += resp.response ? resp.response : 0;
          });
        };

        if ($scope.$parent.currentUser.role === 'ADM') {
          for (var key in callCounters) counter(key);
        } else counter('GROUPS_ADM');
      };

      counters();
    },

    profile: function ($scope, Api, NgTableParams, ReqAndUpload, $q, $translate, $http, $routeParams, formNotify) {
      $scope.preProfile = function (payload) {
        if (payload.slug && /___/.test(payload.slug)) {
          console.error('ERRO DO UNDERSCORE');
          $translate('MESSAGES.USER_SLUG_INVALID_UNDERSCORE').then(function (result) {
            App.toastError(result, 3000);
          });
          return 'ERROR';
        }
      };

      $scope.callbackProfile = function (err, ret) {
        if (ret.response && ret.response.message === 'ALREADY_EXISTS') {
          $translate('MESSAGES.USER_SLUG_ALREADY_EXISTS').then(function (result) {
            App.toastError(result, 3000);
          });
        } else {
          $translate('GLOBAL.ERROR').then((result) => App.toastError(result, 5000));
        }
      };

      let queryString = unserialize(window.location.href.split('?').pop());
      let popupSocial = null;
      $scope.currentTab = 'tab1';
      $scope.user = {};
      $scope.facebook = false;

      // Get user data
      let userGet = function () {
        Api.get('user/get', function (err, resp) {
          if (!err) {
            if (!resp.response.password) $scope.facebook = true;
            $scope.user.email = resp.response.email;
            if (resp.response.phone_number) {
              let regex = /^(\+\d{0,2})(\d{0,2})(\d{0,5})(\d{0,4})/;
              let subst = `$1 ($2) $3-$4`;
              let str = resp.response.phone_number;
              $scope.user.phone_number = str.replace(regex, subst);
            }
            $scope.user.new_email = resp.response.new_email ? resp.response.new_email : false;
            $scope.user.facebook_id = resp.response.facebook_id ? resp.response.facebook_id : false;
            $scope.user.google_id = resp.response.google_id ? resp.response.google_id : false;
            $scope.user.linkedin_id = resp.response.linkedin_id ? resp.response.linkedin_id : false;
            if ($scope.user.facebook_id) $scope.user.facebook = resp.response.facebook;
            if ($scope.user.google_id) $scope.user.google = resp.response.google;
            if ($scope.user.linkedin_id) $scope.user.linkedin = resp.response.linkedin;
          }
        });
      };

      if (queryString['token']) {
        let token = queryString['token'];
        Api.post('auth/email-change-conclusion', { token: token }, function (err, resp) {
          if (!err) {
            $('#confirmChange').openModal();
          } else {
            $translate('PANEL.INVALID_LINK').then(function (result) {
              App.toast(result, 3000);
            });
          }
          userGet();
        });
      } else userGet();

      let closePopupSocial = function () {
        if (popupSocial) {
          popupSocial.close();
        }
      };

      let socialLink = function (data) {
        closePopupSocial();
        if (data.type === 'connectSocial') {
          Api.post(`auth/${data.social}/social-link`, data.payLoad, function (err, resp) {
            if (err) {
              if (resp && resp.data && resp.data.response && resp.data.response.error_id === 70013) {
                $translate(`PANEL.INVALID_${data.social.toUpperCase()}_ACCOUNT`).then(function (result) {
                  App.toastError(result, 5000);
                });
                return;
              }
              $translate('GLOBAL.ERROR').then((result) => App.toastError(result, 5000));
              return;
            }

            if (data.social === 'facebook') {
              $scope.user.facebook_id = resp.response.data.id;
              if ($scope.user.facebook_id) {
                $scope.user.facebook = resp.response.data;
              }
            }

            if (data.social === 'google') {
              $scope.user.google_id = resp.response.data.id;
              if ($scope.user.google_id) {
                $scope.user.google = resp.response.data;
              }
            }

            if (data.social === 'linkedin') {
              $scope.user.linkedin_id = resp.response.data.id;
              if ($scope.user.linkedin_id) {
                $scope.user.linkedin = resp.response.data;
              }
            }
          });
        }
      };

      if (queryString['connect_data']) {
        let data = JSON.parse(queryString['connect_data']);
        socialLink(data);
        window.history.replaceState({}, document.title, window.location.href.split('?')[0]);
      }

      userGet();

      window.addEventListener('message', function (event) {
        if (event.origin.indexOf('squidcommunity.com') === -1 && event.origin.indexOf('duopana.com') === -1) {
          return;
        }
        let data = {};
        try {
          data = JSON.parse(event.data);
        } catch (e) {
          closePopupSocial();
          return;
        }

        socialLink(data);
      });

      // For mobile change tabs
      $scope.changeTab = function (tab) {
        $('ul.tabs').tabs('select_tab', tab);
      };

      // Connect social modal
      $scope.connectSocial = function (action) {
        let dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
        let dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;
        let width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
        let height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
        let w = 650,
          h = 630;
        let left = width / 2 - w / 2 + dualScreenLeft;
        let top = height / 2 - h / 2 + dualScreenTop;
        let lang = bcp.settings.language || 'pt-br';
        let url = `https://squidcommunity.com/auth/connect/${action}?url_redirect=${encodeURIComponent(window.location.href)}&language=${lang}`;
        let title = 'Duopana Social';
        let options = 'width=' + w + ',height=' + h + ',location=no,resizable=no,menubar=no,scrollbars=no,status=no,titlebar=no,toolbar=no, top=' + top + ', left=' + left;
        if (window.innerWidth < 650) {
          window.location.href = url;
        } else {
          popupSocial = window.open(url, title, options);
          if (window.focus) {
            popupSocial.focus();
          }
        }
      };

      $scope.disconnect = function (social) {
        Api.delete(`auth/${social}/social-link`, function (err, resp) {
          if (!err) {
            $translate('PANEL.DATA_UPDATE_SUCCESS').then(function (result) {
              App.toast(result, 3000);
            });

            if (social === 'facebook') {
              $scope.user.facebook_id = false;
            }

            if (social === 'google') {
              $scope.user.google_id = false;
            }

            if (social === 'linkedin') {
              $scope.user.linkedin_id = false;
            }
          }
        });
      };

      $scope.changeEmail = function (data, Form) {
        if (Form.$invalid) {
          formNotify($scope, Form);
          return false;
        }
        var userData = {
          new_email: data.email
        };
        Api.post('auth/email-change', userData, function (err, resp) {
          if (!err && resp.status === 200) {
            $translate('PANEL.EMAIL_UPDATE_SUCCESS').then(function (result) {
              App.toast(result, 3000);
            });
            $scope.user.new_email = data.email;
          }
        });
      };

      $scope.cancelChange = function () {
        Api.delete('auth/email-change', function (err, resp) {
          if (!err) {
            $translate('PANEL.EMAIL_UPDATE_CANCEL').then(function (result) {
              App.toast(result, 3000);
            });
            $scope.user.new_email = false;
            userGet();
          }
        });
      };

      $scope.sendEmail = function (data) {
        Api.post('auth/email-change', { new_email: data.new_email }, function (err, resp) {
          if (!err && resp.status === 200) {
            $translate('PANEL.EMAIL_UPDATE_SUCCESS').then(function (result) {
              App.toast(result, 3000);
            });
          } else {
            var codeMessage = resp.data.response && resp.data.response.error_code ? resp.data.response.error_code : '';
            var msg = codeMessage ? 'PANEL.' + codeMessage : 'PANEL.EMAIL_PROBLEM_CHANGE';

            $translate(msg).then(function (result) {
              App.toastError(result, 3000);
            });
            $scope.user.new_email = false;
          }
        });
      };

      $scope.confirmChangeEmail = function () {
        $('#confirmChange').closeModal();
        if (Object.keys($scope.user).length === 0) {
          window.location.href = '/';
        }
      };
    },

    bookmark: function ($scope, Api) {
      var user = $scope.currentUser;
      $scope.bookmarks = user.bookmark ? user.bookmark : [];
      $scope.deleteBookmark = function (index) {
        if (index !== undefined && $scope.bookmarks[index]._id) {
          var list_id = $scope.bookmarks[index]._id;
          Api.delete(`user/bookmark_delete/${list_id}`, function (err, ret) {
            if (!err) {
              $scope.bookmarks.splice(index, 1);
              user.bookmark = $scope.bookmarks;
              $scope.changeUser(user);
            }
          });
        }
      };
    },

    bookmarkDetail: function ($scope, Api, NgTableParams, ReqAndUpload, $q, $translate) {
      $scope.save = function (item) {
        item.id = item._id;
        Api.post('user/bookmark_save', item, function (err, data) {
          if (!err) {
            $scope.syncData();
            $translate('PANEL.BOOKMARK_UPDATE_SUCCESS').then(function (result) {
              App.toast(result, 3000);
            });
          } else {
            App.toast(data.response, 3000);
          }
        });
      };
    },

    notification: function ($scope, Api) {
      $scope.messages = [];
      $scope.currentPage = 1;
      $scope.last = true;
      $scope.noresults = false;

      $scope.loadMore = function () {
        $scope.last = true;
        Api.get(`user/get_messages?page=${$scope.currentPage}`, function (err, data) {
          if (!err) {
            $scope.currentPage++;
            $scope.messages = $scope.messages.concat(data.response);
            if (data.response.length == 20) $scope.last = false;
            else if ($scope.currentPage === 0) $scope.noresults = true;
          }
        });
      };
      $scope.loadMore();
    },

    tag: function ($scope, Api, NgTableParams, ReqAndUpload, $q, $translate) {
      var user = $scope.currentUser;
      $scope.tags = [];
      $scope.user_tags = [];
      $scope.user = {};
      $scope.user.tags = user.tags ? user.tags : [];

      Api.post('tag/list', { tags: user.tags }, function (err, data) {
        if (!err) $scope.user_tags = data.response;
      });

      $scope.tagRemove = function (index) {
        var tag = $scope.user_tags[index];
        var index2 = $scope.user.tags.indexOf(tag._id);
        if (tag && index2 > -1) {
          $scope.user.tags.splice(index2, 1);
          $scope.user_tags.splice(index, 1);
          user.tags = $scope.user.tags;
        }
      };

      // Save user data
      $scope.save = function (data) {
        Api.post('user/update', data, function (err, resp) {
          if (!err) {
            $scope.changeUser(user);
            App.toast(resp.response, 3000);
          }
        });
      };
    },

    inbox: function ($scope, Api, NgTableParams, ReqAndUpload, $q, $translate) {
      var user_id = $scope.params.user ? $scope.params.user : '';
      window.location.href = '/v2/user/conversations/' + user_id;
      return;
    }
  };
})();
